/** @format */

export enum TextWeight {
  bold = "bold",
  regular = "normal",
}
